// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3r-C4","errorLogs":"styles_errorLogs__3vEp1"};